import gql from 'graphql-tag'
import Organization from '~/models/organization'
import Activity from '~/models/activity'

interface LoginDataResponse {
  access_token: string
  activity: Activity
  organization: Organization
}

export interface LoginResponse {
  login: LoginDataResponse
}

export interface LoginVars {
  email: string
  password: string
  ip?: string
  user_agent?: string
}

export const LOGIN = gql`
  query Login (
    $email: String!
    $password: String!
    $ip: String
    $user_agent: String
  ) {
    login (
      email: $email
      password: $password
      ip: $ip
      user_agent: $user_agent
    ) {
      access_token
      organization {
        code
      }
      activity {
        organization {
          code
        }
        service {
          code
        }
        system {
          code
        }
      }
    }
  }
`
